import Vue from 'vue';
import $bizConfig from '@/models/bizConfig.js';
import $web3js from '../web3.js';
import $erc20 from '../erc20/index.js';
import $utils from "@/lib/utils/index.js";
import $numberUtils from '@/models/numberUtils.js';

const contractInfo = require('./LockMining.json')

let web3 = $web3js.getWeb3();

let contractAddress = $bizConfig.LockUsdtMiningContractAddress; //=========
let ifilcontractAddress = $erc20.getErc20Address('USDT');
let dmccontractAddress = $erc20.getErc20Address('DMC');
let contractConst = {
    contract: web3 ? new web3.eth.Contract(contractInfo.abi, contractAddress) : '',
}

const getUsdtLockMiningAddress = () => {
    return contractAddress;
}

const getUsdtLockMiningContract = () => {
    return contractConst.contract;
}

const getUsdtLockMiningPoolInfo = async([_pid], options) => {
    return $web3js.call(getUsdtLockMiningContract().methods.getPoolInfo, [_pid], options, handLockMiningPoolInfo);
}

const handLockMiningPoolInfo = async(res) => {
    let index = 0;
    let pid = res[index++];
    let issueId = res[index++];
    let lockedDays = res[index++];
    let startTime = res[index++];
    let startBlock = res[index++];
    let limitCount = res[index++];
    let maxAmount = res[index++];
    let depositAmount = res[index++];
    let withdrawAmount = res[index++];
    let estimateBenefit = res[index++];
    let withdrawnBenefit = res[index++];
    let dmcAmount = res[index++];
    let withdrawnDmcAmount = res[index++];
    let pledgeToken = res[index++];
    let dmcToken = res[index++];
    let benefitToken = res[index++];
    let apy = res[index++];
    let extraApys = res[index++];
    let gainedBlock = res[index++];
    let state = res[index++];
    let remainAmount = $numberUtils.sub(maxAmount, depositAmount);

    maxAmount = await $erc20.fromErc20Value(maxAmount, ifilcontractAddress);
    depositAmount = await $erc20.fromErc20Value(depositAmount, ifilcontractAddress);
    remainAmount = await $erc20.fromErc20Value(remainAmount, ifilcontractAddress);
    withdrawAmount = await $erc20.fromErc20Value(withdrawAmount, ifilcontractAddress);
    estimateBenefit = await $erc20.fromErc20Value(estimateBenefit, ifilcontractAddress);
    withdrawnBenefit = await $erc20.fromErc20Value(withdrawnBenefit, ifilcontractAddress);
    dmcAmount = await $erc20.fromErc20Value(dmcAmount, dmccontractAddress);
    withdrawnDmcAmount = await $erc20.fromErc20Value(withdrawnDmcAmount, dmccontractAddress);
    apy = $numberUtils.div(apy, 10000);
    let extraApy = $numberUtils.div(extraApys[2], 10000);


    return {
        pid,
        lockedDays,
        limitCount,
        maxAmount,
        depositAmount,
        remainAmount,
        withdrawAmount,
        estimateBenefit,
        withdrawnBenefit,
        dmcAmount,
        withdrawnDmcAmount,
        apy,
        extraApys,
        extraApy,
        state



    }
}


const getUsdtLockMiningUserInfo = async([_user, _pid], options) => {
    return $web3js.call(getUsdtLockMiningContract().methods.getUserInfo, [_user, _pid], options, handLockMiningUserInfo);
}


const toUsdtLockMining = async([_pid, _extraApy, _amount], options, callback) => {
    _amount = await $erc20.toErc20Value(_amount, ifilcontractAddress);
    return $web3js.send(getUsdtLockMiningContract().methods.lock, [_pid, _extraApy, _amount], options, callback);
}

const toUsdtLockMiningEstimateSend = async([_pid, _extraApy, _amount], options) => {
    _amount = await $erc20.toErc20Value(_amount, ifilcontractAddress);

    let gasPromise;
    // if (!!_aggregator && !!_joinPid) {
    //     _joinPid = $web3js.stringToBytes32(_joinPid);
    //     gasPromise = $web3js.estimateSend(getUsdtLockMiningContract().methods.lock, [_pid,_extraApy,_amount], options);
    // } else {
    //     gasPromise = $web3js.estimateSend(getUsdtLockMiningContract().methods.lock, [_pid, _amount], options);
    // }
    gasPromise = $web3js.estimateSend(getUsdtLockMiningContract().methods.lock, [_pid, _extraApy, _amount], options);
    let gasPricePromise = $web3js.getGasPrice();

    let [e1, gas] = await $utils.awaitWrap(gasPromise);
    let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
    if (!!e1) {
        Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
        return null;
    }

    let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
    return { gas, gasPrice, fee };
}

const toUsdtWithdrawMining = ([_pid], options, callback) => {
    return $web3js.send(getUsdtLockMiningContract().methods.withdraw, [_pid], options, callback);
}

const toUsdtWithdrawMiningEstimateSend = async([_pid], options) => {
    let gasPromise;
    // if (!!_aggregator && !!_joinPid) {
    //     _joinPid = $web3js.stringToBytes32(_joinPid);
    //     gasPromise = $web3js.estimateSend(getUsdtLockMiningContract().methods.lock, [_pid,_extraApy,_amount], options);
    // } else {
    //     gasPromise = $web3js.estimateSend(getUsdtLockMiningContract().methods.lock, [_pid, _amount], options);
    // }
    gasPromise = $web3js.estimateSend(getUsdtLockMiningContract().methods.withdraw, [_pid], options);
    let gasPricePromise = $web3js.getGasPrice();

    let [e1, gas] = await $utils.awaitWrap(gasPromise);
    let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
    if (!!e1) {
        Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
        return null;
    }

    let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
    return { gas, gasPrice, fee };
}

const handLockMiningUserInfo = async(res) => {
    let index = 0;
    let pid = res[index++];
    let issueId = res[index++];
    let lockedDays = res[index++];
    let baseApy = res[index++];
    let extraApy = res[index++];
    let poolRemainAmount = res[index++];
    let filAmount = res[index++];
    let dmcAmount = res[index++];
    let availBenefit = res[index++];
    let availDmcAmount = res[index++];
    let state = res[index++];
    let contractAddress=$bizConfig.LockUsdtMiningContractAddress

    poolRemainAmount = await $erc20.fromErc20Value(poolRemainAmount, ifilcontractAddress);
    filAmount = await $erc20.fromErc20Value(filAmount, ifilcontractAddress);
    dmcAmount = await $erc20.fromErc20Value(dmcAmount, dmccontractAddress);
    availBenefit = await $erc20.fromErc20Value(availBenefit, ifilcontractAddress);
    availDmcAmount = await $erc20.fromErc20Value(availDmcAmount, dmccontractAddress);
    baseApy = $numberUtils.div(baseApy, 10000);
    extraApy = $numberUtils.div(extraApy, 10000);


    return {
        pid,
        lockedDays,
        baseApy,
        extraApy,
        poolRemainAmount,
        filAmount,
        dmcAmount,
        availBenefit,
        availDmcAmount,
        state,
        contractAddress

    }
}


const getUsdtLockMiningPoolState = async([_pid], options) => {
    return $web3js.call(getUsdtLockMiningContract().methods.getPoolState, [_pid], options);
}

const getUsdtLockMiningCalcLockInfo = async([_pid, _amount, _extraApy], options) => {
    _amount = await $erc20.toErc20Value(_amount, ifilcontractAddress);
    return $web3js.call(getUsdtLockMiningContract().methods.calcLockInfo, [_pid, _amount, _extraApy], options, handLockMiningCalcLockInfo);
}

const handLockMiningCalcLockInfo = async(res) => {
    let index = 0;
    let remainLock = res[index++];
    let filBalance = res[index++];
    let dmcBalance = res[index++];
    let lockDmcAmount = res[index++];
    let reaminCount = res[index++];

    filBalance = await $erc20.fromErc20Value(filBalance, ifilcontractAddress);
    dmcBalance = await $erc20.fromErc20Value(dmcBalance, dmccontractAddress);
    lockDmcAmount = await $erc20.fromErc20Value(lockDmcAmount, dmccontractAddress);
    return {
        remainLock,
        filBalance,
        dmcBalance,
        lockDmcAmount,
        reaminCount
    }
}




export default {
    getUsdtLockMiningAddress,
    getUsdtLockMiningContract,
    getUsdtLockMiningPoolInfo,
    getUsdtLockMiningPoolState,   
    getUsdtLockMiningUserInfo,
    toUsdtLockMining,
    toUsdtLockMiningEstimateSend,
    toUsdtWithdrawMining,
    toUsdtWithdrawMiningEstimateSend,
    getUsdtLockMiningCalcLockInfo
}


// WEBPACK FOOTER //
// ./src/lib/contract/usdtLockMining/index.js